import axios from 'axios';
import auth from '../utils/auth';
import { default as config } from '../config';

// let sites = ['BOP', 'SHOP'];

export const getCategories = async () => {
    let siteCats = {};
    for (let site of config.sites) {
        try {
            let { data } = await axios.get(`/products/categories/${site.key}?full=true`);
            if (typeof data[0] === 'string') {
                data = data.map((path) => ({ category_name: path }));
            }
            siteCats[site.key] = data;
        } catch {
            siteCats[site.key] = [];
        }
    }

    return siteCats;
};

export function getCategoryInfo(catPath) {
    return axios.get(`/products/category/${catPath}?start=0&sort=title%3Aasc&page_size=200&sales_territory_rights=US`);
}

export function getProducts(catPath) {
    return axios.get(`/products/category${catPath}`);
}

export function getCategory(catPath) {
    return axios.request({
        url: `/categories/${catPath}`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        }
    });
}

export function saveCategory(catPath, data) {
    return axios.request({
        url: `/categories/${catPath}`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        },
        data: data
    });
}

export function getCollections() {
    return axios.request({
        url: `/categories/collections`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        }
    });
}

export function activateCategory(id) {
    return axios.request({
        url: `/categories/${id}/activate`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        }
    });
}

export function inactivateCategory(id) {
    return axios.request({
        url: `/categories/${id}/inactivate`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        }
    });
}
